import { createSlice } from '@reduxjs/toolkit';

const textToVoiceSlice = createSlice({
  name: 'textToVoice',
  initialState: {
    // complete unknown right now, put it here as placeholder
    transcriptions: {},
    calls: {},
    // The states for posting text
    postMessage: {
      loading: false,
      error: null,
    },
    visible: false,
  },
  reducers: {
    activateInput: (state, action) => {
      const callerId = action.payload;
      if (!state.calls[callerId]) {
        state.calls[callerId] = {
          visible: true,
        };
      } else if (!state.calls[callerId].visible) {
        state.calls[callerId].visible = true;
      }
    },
  },
});

export const { activateInput } = textToVoiceSlice.actions;

export const textToVoiceReducer = textToVoiceSlice.reducer;
export default textToVoiceReducer;
